'use client';
import e__default, { useMemo, useEffect } from 'react';
import { swanLoaderConfigProps, SwanContext } from './swan-provider.context.js';
import { createSwanVersionMetaTag, createSwanGlobalObject } from '../../../core/utilities/swan-version.js';
import { loadSwanPolyfill } from '../../../core/utilities/load-polyfill.js';
import { SwanPathTypeEnum } from '../../../core/types/enums.js';
import { getSwanBaseUrl } from '../../../core/utilities/base-url.utils.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
createSwanVersionMetaTag();
let y = _object_spread_props(_object_spread({}, swanLoaderConfigProps), {
    pathType: swanLoaderConfigProps.swanPathType
}), b = SwanPathTypeEnum.hashed;
const SwanProvider = ({ swanBaseUrl: o, pathType: p, swanPathType: s, swanTenant: y, swanLocale: l, globalLinkComponent: f, children: u })=>{
    let O = o || getSwanBaseUrl(y, l), w = s || p || b, j = useMemo(()=>({
            globalLinkComponent: f,
            swanBaseUrl: O,
            swanPathType: w,
            swanTenant: y,
            swanLocale: l
        }), [
        f,
        O,
        w,
        y,
        l
    ]);
    return useEffect(()=>{
        createSwanGlobalObject(j.swanBaseUrl);
    }, [
        j.swanBaseUrl
    ]), useEffect(()=>{
        loadSwanPolyfill(O);
    }, [
        O
    ]), e__default.createElement(SwanContext.Provider, {
        value: j
    }, u);
};
SwanProvider.displayName = 'SwanProvider', SwanProvider.propTypes = y;

export { SwanProvider };
